import { useAppStore } from '@/store';
import type { CurrentUserSlice } from '@/store/slices/currentUser';

export const useCurrentUser = (): CurrentUserSlice['currentUser']['user'] => useAppStore((s) => s.currentUser.user);

// gloss
export const useCurrentUserUuid = (): string => {
  const user = useAppStore((s) => s.currentUser.user);
  return user?.uuid ?? '';
};

export const useIsCurrentUserHydrated = (): boolean => useAppStore((s) => s.currentUser.isHydrated);

export const useCurrentUserError = (): Error | null => useAppStore((s) => s.currentUser.error);

export const useInitializeCurrentUser = (): CurrentUserSlice['currentUser']['initialize'] =>
  useAppStore((s) => s.currentUser.initialize);

export const useRefreshCurrentUser = (): CurrentUserSlice['currentUser']['refreshMe'] =>
  useAppStore((s) => s.currentUser.refreshMe);

export const useClearCurrentUser = (): CurrentUserSlice['currentUser']['clear'] =>
  useAppStore((s) => s.currentUser.clear);
